import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AddProduct from "./AddProduct";
import { Table } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCCJobOrderImportCurrencyList, getCCJobOrderImportHSNRITCCodesList, getCCJobOrderImportInvoiceList } from '../../../../../../../Redux/action/CustomClearance/CCAction';
import AddInvoice from './AddInvoice';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
import EditInvoice from './EditInvoice';
import Swal from 'sweetalert2';
import { adminMainUrl } from '../../../../../../../Config';
import axios from 'axios';

const InvoiceTab = ({ token, user_id, b64id, refresh }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  const [invoice_id, setInvoice_id] = useState(0);


  const [editShow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = (id) => {
    setEditShow(true);
    setInvoice_id(id);
  }

  const handleDelete = (id) => {

    let config = {
      // method: "GET",
      headers: {
        'auth-token': token,
        'user_id': user_id,
        'Content-Type': 'application/json',
      }
    };
    if (!id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "ID not provided!",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`${adminMainUrl}/api/customClearance/import/invoice/delete`,
          {
            id: id,
            custom_clearance_import_job_id: atob(b64id)
          },
          config 
        ) // Replace with your API endpoint
          .then((response) => {
            // Success alert
            if (response.status == 200) {
              refresh();
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: response.data.msg,
              });
            }else{
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: response.data.msg,
              });
            }

          })
          .catch((error) => {
            // Error alert
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong. Please try again.",
            });
          });
      }
    });
  };




  useEffect(() => {
    if (token && user_id) {
      dispatch(getCCJobOrderImportCurrencyList(token, user_id));
      if (b64id) {
        let id = atob(b64id);
        if (id) {
          dispatch(getCCJobOrderImportInvoiceList(token, user_id, id));
        }
      }
    }
  }, [token, user_id, b64id]);

  // const refresh = () => {
  //   if (token && user_id && b64id) {
  //     let id = atob(b64id);
  //     if (id) {
  //       dispatch(getCCJobOrderImportInvoiceList(token, user_id, id));
  //     }
  //   }
  // };

  const {
    loadingCCImportJobCurrencyList,
    CCImportJobCurrencyListData,
    CCImportJobCurrencyListDataError,

    loadingCCImportJobInvoiceList,
    CCImportJobInvoiceListData,
    CCImportJobInvoiceListDataError,
  } = useSelector(state => state?.CCReducer);

  //table data
  let [invoiceData, setInvoiceData] = useState([]);
  let [showLoader, setShowLoder] = useState(false);

  useEffect(() => {
    if (loadingCCImportJobInvoiceList) {
      setShowLoder(true);
    } else {
      setShowLoder(false);
    }

    if (CCImportJobInvoiceListData) {
      setInvoiceData(CCImportJobInvoiceListData);
    }
  }, [loadingCCImportJobInvoiceList, CCImportJobInvoiceListData])


  const [currencyOptions, setCurrencyOptions] = useState([]);
  useEffect(() => {
    if (CCImportJobCurrencyListData) {
      let arr = [];
      CCImportJobCurrencyListData.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
      setCurrencyOptions(arr);
    }
  }, [loadingCCImportJobCurrencyList, CCImportJobCurrencyListData,])


  return (

    <>
      {
        showLoader ?
          <Beatloader />
          :
          <>

            <div className="card">

              <div className="card-body">
                <div className="d-flex justify-content-end mb-4">
                  <div
                    className="btn btn-primary cursor-pointer me-2"
                    onClick={handleAddShow}
                  // onClick={() => { navigate("#") }}
                  >
                    <i className="ti ti-square-rounded-plus me-2" />
                    Add
                  </div>
                </div>

                <div className="table-responsive custom-table">
                  {/* <Table className="table datanew dataTable no-footer" pagination={false}
                    dataSource={dataSource} columns={columns} /> */}
                  <table className="table table-striped table-sm">
                    <thead>
                      <tr>
                        <th scope="col">S.NO.</th>
                        <th scope="col">Invoice No.</th>
                        <th scope="col">Date</th>
                        <th scope="col">TOI</th>
                        <th scope="col">Invoice Value</th>
                        <th scope="col">Product Value(FOB)</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {
                        invoiceData?.length > 0 ?
                          invoiceData?.map((val, index) => {
                            return <tr key={index + 1}>
                              <th scope="row">{index + 1}</th>
                              <td>{val?.invoice_no}</td>
                              <td>{val?.invoice_date}</td>
                              <td>{val?.TOI_type}</td>
                              <td>{val?.invoice_value}</td>
                              <td>{val?.product_value}</td>
                              <td><div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                  <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                  <div className="dropdown-item cursor-pointer"
                                    onClick={() => handleEditShow(val?.id)}
                                  >
                                    <i className="fas fa-edit text-blue me-2"></i> Edit
                                  </div>
                                  <div className="dropdown-item cursor-pointer"
                                    onClick={() => handleDelete(val?.id)}
                                  >
                                    <i className="fa-solid fa-trash text-blue me-2"></i> Delete
                                  </div>
                                </div>
                              </div>
                              </td>
                            </tr>
                          }) :
                          <>
                            <tr>
                              <td colSpan={7}> <i>No data found.</i></td>
                            </tr>
                          </>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <AddInvoice
              addShow={addShow}
              handleAddClose={handleAddClose}
              refresh={refresh}

              token={token}
              user_id={user_id}
              b64id={b64id}

              loadingCCImportJobCurrencyList={loadingCCImportJobCurrencyList}
              currencyOptions={currencyOptions}
            />
            <EditInvoice
              addShow={editShow}
              handleAddClose={handleEditClose}
              refresh={refresh}

              token={token}
              user_id={user_id}
              b64id={b64id}
              invoice_id={invoice_id}

              loadingCCImportJobCurrencyList={loadingCCImportJobCurrencyList}
              currencyOptions={currencyOptions}
            />
          </>
      }
    </>

  )
}

export default InvoiceTab